// refactor
// too many subscribtions
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-edit-corner-posts',
  templateUrl: './edit-corner-posts.component.html',
  styleUrls: ['./edit-corner-posts.component.scss']
})
export class EditCornerPostsComponent implements OnInit {

  @Output() step2Editer = new EventEmitter();
  single: boolean = true;
  double: boolean = true;

  railingType: string;
  postMounting: string;
  infill: string;
  selectedPosts = {
    single : false,
    double : false
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }
  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService
  ) { 
    this.dataForMenu.cornerPosts.subscribe(cornerePostType =>this.setSelectedSettings(cornerePostType))
  }

  setCornerPosts(value: string) {
    this.dataForMenu.setCornerPosts(value);
  }

  setSingleDoubleAvailability() {
    if (this.railingType === 'Modern') {
      // "Single Corner Type only" (spec p.2 rule 2)
      this.single = true;
      this.double = false;
    }
    else if (this.railingType == 'DesignRail' && this.postMounting == 'stanchion' && this.infill == 'horizontal') {
      this.single = true;
      this.double = false;
    }
    else if (this.railingType == 'Composite') {
      this.single = true;
      this.double = false;
    }
    else if (this.railingType === 'Wood' && this.postMounting === 'Fascia Mount') {
      this.single = false;
      this.double = true;
    }
    else if (this.railingType === 'Steel round tubular' && this.postMounting === 'Fascia Mount') {
      this.single = false;
      this.double = true;
    }
    else if (this.railingType === 'DesignRail' && this.postMounting === 'Fascia Mount') {
      this.single = false;
      this.double = true;
    }
    else {
      this.single = true;
      this.double = true;
    }
  }

  ngOnInit() {
    this.dataForMenu.railingType.subscribe(value => {
      this.railingType = value;
      this.setSingleDoubleAvailability();
    });
    this.dataForMenu.postMounting.subscribe(value => {
      this.postMounting = value;
      this.setSingleDoubleAvailability();
    });
    this.dataForMenu.infill.subscribe(value => {
      this.infill = value;
      this.setSingleDoubleAvailability();
    });
  }

  setSelectedSettings(value){
    switch(value)  {
      case 'Single': {
        this.clearSelection();
        this.selectedPosts.single = true;
        break;
      }
      case 'Double': {
        this.clearSelection();
        this.selectedPosts.double = true;
        break;
      }
    }
  }

  clearSelection(){
    this.selectedPosts = {
      single : false,
      double : false
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/edit-corner-posts/edit-corner-posts.component.ts